import React from 'react';
import shared from '../../../../app/_landing/section-shared.module.scss';
import LoopVideo from '../../components/loop-video/LoopVideo';
import styles from './product-landing.module.scss';

export { styles };

export function SectionHeader({ title, intro, left = false }: {
  title: string;
  intro?: string;
  left?: boolean;
}) {
  return (
    <div className={`${shared.sectionIntro} ${left ? styles.leftIntro : ''}`}>
      <h2 className={shared.sectionTitle}>{title}</h2>
      {intro && <p className={shared.sectionDescription}>{intro}</p>}
    </div>
  );
}

export function ProductHero({ eyebrow, title, intro, children, preview }: {
  eyebrow: string;
  title: string;
  intro: string;
  children: React.ReactNode;
  preview: React.ReactNode;
}) {
  return (
    <section className={styles.hero}>
      <div className={styles.split}>
        <div>
          <p className={styles.eyebrow}>{eyebrow}</p>
          {/* The server page owns the sole H1 used for SEO. */}
          <h2 className={styles.heroTitle}>{title}</h2>
          <p className={styles.heroLead}>{intro}</p>
          <div className={styles.actions}>{children}</div>
        </div>
        {preview}
      </div>
    </section>
  );
}

export function FinalCta({ title, intro, children }: {
  title: string;
  intro?: string;
  children: React.ReactNode;
}) {
  return (
    <section className={styles.finalCta}>
      <h2 className={shared.sectionTitle}>{title}</h2>
      {intro && <p>{intro}</p>}
      {children}
    </section>
  );
}

export function Steps({ title, items, id, media }: {
  title: string;
  items: { label: string; desc: string }[];
  id?: string;
  /** Optional decorative loop per step (asset path without extension), by index. */
  media?: (string | undefined)[];
}) {
  return (
    <section id={id} className={styles.section}>
      <SectionHeader title={title} />
      <ol className={styles.steps}>
        {items.map((step, index) => (
          <li key={step.label} className={`${styles.card} ${media?.[index] ? styles.mediaCard : ''}`}>
            {media?.[index] && <LoopVideo src={media[index] as string} className={styles.cardMedia} />}
            <span className={styles.stepNumber} aria-hidden="true">{index + 1}</span>
            <h3>{step.label}</h3>
            <p>{step.desc}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
